module.exports = __webpack_public_path__ + "static/pattern@2x-0aeda4207ad9e044b2dd2eb58c6c1ae2.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/why-marvel/pattern@2x.png
// module id = 2722
// module chunks = 168707334958949